import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ApiHandlerService {
  constructor() {}

  /**
   * Function to Add Custom Headers and return it
   * @param paramsArr Array<Object>
   * @return params
   */
  generateParams(paramsObj: any) {
    const paramsArr = Object.entries(paramsObj);
    let _params = new HttpParams();
    paramsArr.forEach(([key, value]) => {
      let param: any = {};
      param[key] = value;
      _params = _params.appendAll(param);
    });
    return _params;
  }
}
